var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoneRecipeHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.773842,
    y: 0.773842,
    width: 37.1444,
    height: 37.1444,
    rx: 18.5722,
    stroke: "#FCC436",
    strokeWidth: 1.54768
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6072 8.53861L39.6075 8.53827C40.6986 7.44721 40.6986 5.70037 39.6075 4.60931L38.9004 5.31642L39.6075 4.60931C38.5165 3.51825 36.7696 3.51825 35.6786 4.60931L36.3857 5.31642L35.6786 4.60931L18.6028 21.6851L13.023 16.1053C11.932 15.0142 10.1851 15.0142 9.09405 16.1053C8.00299 17.1964 8.00299 18.9432 9.09405 20.0343L16.6203 27.5606C17.7114 28.6516 19.4762 28.6516 20.5673 27.5606L39.6072 8.53861Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneRecipeHeader);
export default __webpack_public_path__ + "static/media/doneRecipeHeader.ce616090de1bd989f1c4f744d6d87010.svg";
export { ForwardRef as ReactComponent };